import { Action, createReducer, on } from '@ngrx/store';

import { Category } from './categories.models';
import {
  BookingSelectServicesCategoriesActions,
  BookingSelectServicesCategoriesApiActions,
} from './categories.actions';

export interface CategoriesState {
  entities: Array<Category>;
  loading: boolean;
}

const initialState: CategoriesState = {
  entities: [],
  loading: false,
};

const categoriesReducer = createReducer(
  initialState,
  on(
    BookingSelectServicesCategoriesActions.loadCategories,
    (state): CategoriesState => ({
      ...state,
      loading: true,
    })
  ),
  on(
    BookingSelectServicesCategoriesApiActions.loadCategoriesSuccess,
    (state, { categories }): CategoriesState => ({
      ...state,
      loading: false,
      entities: categories,
    })
  ),
  on(
    BookingSelectServicesCategoriesApiActions.loadCategoriesFailure,
    (state): CategoriesState => ({
      ...state,
      loading: false,
    })
  )
);

export function reducer(state: CategoriesState | undefined, action: Action) {
  return categoriesReducer(state, action);
}
